import React from "react";

export default function CardRibbon({ auctionCategory }) {
  return (
    <div
      className="position-absolute"
      style={{
        paddingTop: "3px",
        paddingBottom: "3px",
        color: "#FFFFFF",
        background: "#CF1701",
        fontWeight: "600",
        fontSize: "14px",
        lineHeight: "20px",
        paddingLeft: "12px",
        paddingRight: "8px",
        borderTopRightRadius: "8px",
        borderBottomLeftRadius: "20px",
        marginTop: "-1px",
        right: "0",
        top: "0",
        zIndex: "1",
      }}
    >
      LIVE
    </div>
  );
}
